<template>
  <div class="base-checkbox__items">
    <div 
      v-for="(item,index) in items"
      :key="index"
      :model="model"
      class="base-checkbox"
    >
      <input
        :id="item.id"
        class="base-checkbox__input"
        type="checkbox"
        :value="item.id"
      >
      <label 
        :for="item.id"
      >
        {{ item.title }}
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseCheckboxGroup',

    props: {
      items: {
        type: Array,
        default: () => []
      },
      model: {
        type: String,
        default: ''
      }
    }
    
  }
</script>

<style lang="scss">

</style>
